import React from 'react'
import moment from 'moment'
import t from '../../service/translate.service'
import PropTypes from 'prop-types'
import { RepairsAndInquiriesImage } from '../../components/icons'
import NoContent from '../../components/NoContent'

const RepairsAndInquiriesItems = props => {
  const { items, selectedItem, handleClick, itemContentComponent, actions, store, navigate } = props

  return (
    <div>
      <div>
        <div className='list'>
          {items.map(item => {
            const activeClass = item.code === selectedItem.code ? 'active' : ''
            const statusClass = item?.repairAndInquiryStatus?.name?.toLowerCase()?.replace(' ', '-')
            return (
              <div
                key={item.code}
                className='item'
              >
                <div className={`container ${activeClass}`} style={{ position: 'relative' }}>
                  {/* Edit button in top-right corner 
                  <button
                    className='edit-button'
                    onClick={e => {
                      e.preventDefault()
                      e.stopPropagation()
                      if (navigate) {
                        navigate(`/repairs-and-inquiries/edit-request/${item.code}`)
                      }
                    }}
                    title={t.SR_STEP_BUTTON_EDIT}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      padding: '6px 12px',
                      fontSize: 'var(--font-size-12)',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: '#f5f5f5',
                      cursor: 'pointer',
                      zIndex: 1
                    }}
                  >
                    {t.SR_STEP_BUTTON_EDIT}
                  </button>
                  
                  {/* Preview button below edit button - only show when not active 
                  {activeClass !== 'active' && (
                    <button
                      className='preview-button'
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        handleClick(item.code)
                      }}
                      title={t.SR_STEP_BUTTON_PREVIEW}
                      style={{
                        position: 'absolute',
                        top: '50px',
                        right: '10px',
                        padding: '6px 12px',
                        fontSize: 'var(--font-size-12)',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer',
                        zIndex: 1
                      }}
                    >
                      {t.SR_STEP_BUTTON_PREVIEW}
                    </button>
                  )}
                  */}
                  <a
                    href=''
                    className='summary'
                    onClick={e => {
                      if (e.key !== 'Tab') {
                        e.preventDefault()
                      }
                      handleClick(item.code)
                    }}
                    style={{
                      textDecoration: 'none',
                      color: 'unset'
                    }}
                  >
                    <div className='group'>
                      <div className='group'>
                        <div className={`status ${statusClass}`}>
                          {localStorage.getItem('locale') === 'en' ? item?.repairAndInquiryStatus?.name : item?.repairAndInquiryStatus?.nameDe}
                        </div>
                        <div className='service-request-id'>
                          {item.ticketnr}
                        </div>
                        {item.urgency === 'Urgent' && (
                          <div className='urgent'>
                            {item.urgency === 'Urgent' ? t.URGENT : ''}
                          </div>
                        )}
                      </div>
                      <p>{item.subject}</p>
                      <div className='date'>
                        {t.SUBMITTED_ON + ' '} {moment(item.create_date).format('D.M.Y')}
                      </div>
                    </div>
                    <div className='icon next'>
                      {/* Preview button moved to top-right area */}
                    </div>
                  </a>
                  {itemContentComponent &&
                    React.cloneElement(itemContentComponent, { item })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
      {store.showLoadMore ? (
        <div className='actions'>
          <button
            type='button'
            className={`button primary`}
            onClick={e => {
              const page = store.page
              const pageSize = store.pageSize
              store.page = page + 1
              store.getReports(page + 1, pageSize, store.activeStatus)
            }}
            style={{
              marginTop: '26px'
            }}
          >
            {t.LOAD_MORE}
          </button>
        </div>
      ) : (
        <></>
      )}
      {!items?.length > 0 && store.activeStatus !== '0' ? (
        <div style={{
          marginTop: '30px',
          marginBottom: '30px'
        }}>
          <NoContent
            message={t.NO_REPORTS_FILTER}
            image={RepairsAndInquiriesImage}
          />
        </div>
      ) : (
        <Actions actions={actions} />
      )}
    </div>
  )
}

const Actions = props => {
  const { actions } = props
  return (
    <div className='actions'>
      {actions.map((action, index) => {
        const classes = action.classes
        return (
          <a
            href=''
            key={index}
            className={`button ${classes}`}
            onClick={e => {
              if (e.key !== 'Tab') {
                e.preventDefault()
              }
              action.onClick()
            }}
            style={{
              textDecoration: 'none',
              color: 'unset',
              marginTop: '26px'
            }}
          >
            {action.text}
          </a>
        )
      })}
    </div>
  )
}
Actions.propTypes = {
  actions: PropTypes.array
}
RepairsAndInquiriesItems.propTypes = {
  items: PropTypes.array,
  selectedItem: PropTypes.object,
  handleClick: PropTypes.func,
  itemContentComponent: PropTypes.object,
  actions: PropTypes.array,
  store: PropTypes.object,
  navigate: PropTypes.func
}
export default RepairsAndInquiriesItems
